import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Button from '@material-ui/core/Button';
import SubscriptionForm from './Subscription__Form';
import useCustomerSettings from 'CustomHooks/useCustomerSettings';
import { useHistory } from 'react-router-dom';
import useGuiTranslations from '../../Components/MultiLanguage/useGuiTranslations';

export default function Subscription(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const getCustomerSettingsHookResponse = useCustomerSettings();
    const {accountStatus, remainingTimeInDays,upcomingInvoice} = getCustomerSettingsHookResponse;
    const history = useHistory();
    const [translateGui] = useGuiTranslations();

    useEffect(
        () => {
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: '8',
                        b: '102'
                    },
                }
            )
        }, []
    )


    const redirectToRelevantSubsPage = () => {
        if (globalContext.globalState.customerSettings.country == 'TR') {
            history.push('/PaynetSubscriptionForm');
        }
    }

    return (
        <div className={classes.root}>
            
            {
                accountStatus == 'Trial'  ?
                    <div className={classes.subscribeWrapper}>
                        <span className={classes.message}>
                        {translateGui(104)} {remainingTimeInDays} 
                    </span>
                        <Button color="primary" onClick={() => { redirectToRelevantSubsPage() }} component="div" variant="contained" >
                        {translateGui(105)}
                        </Button>
                    </div>
                    : null
            }
            {
                accountStatus == 'Regular'  ?
                    <div className={classes.subscribeWrapper}>
                        <span className={classes.message}>
                            {translateGui(103)} {new Date(upcomingInvoice.periodEnd).toLocaleDateString()}
                        </span>
                    </div>
                    : null
            }
            {
                accountStatus == 'Expired'  ?
                    <div className={classes.subscribeWrapper}>
                        <span className={classes.message}>
                        {translateGui(106)}
                        </span>
                        <Button color="primary" onClick={() => { redirectToRelevantSubsPage() }} component="div" variant="contained" >
                        {translateGui(105)}
                        </Button>
                    </div>
                    : null
            }
            

        </div>
    )
}

const useStyles = makeStyles({
    root: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },

    subscribeWrapper: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
    },

    message: {
        marginBottom: '20px',
    }
});
